import {defineMessages} from 'react-intl';

export default defineMessages({
	hide: {
		id: 'forms.fields.password.controls.hide',
		defaultMessage: 'Hide',
	},
	show: {
		id: 'forms.fields.password.controls.show',
		defaultMessage: 'Show',
	},
});
